/**
 * @since 0.29.0
 * @component
 */
export default {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  UP: 38,
  DOWN: 40,
  DELETE: 46,
} as const;
